import React, { Fragment, useEffect, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, GridColumn as Column,  GridColumnMenuSort, GridColumnMenuFilter, GridColumnMenuGroup, GRID_COL_INDEX_ATTRIBUTE, } from "@progress/kendo-react-grid";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { DropDownListById } from "../../forms/form-components";
import { useTableKeyboardNavigation, setExpandedState, setGroupIds, } from "@progress/kendo-react-data-tools";
import { orderBy, process, groupBy } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ReportingWidget } from "./reportingwidget";
import { dateFormats, formatNumber, formatDate, getUnaryComparisonOperatorsByDataType, compareUnary, getThemeColors } from "../../lib/utils";
import { WIDGET_GRID, fontSizes, thousandSeparators, decimalPlaces, hAlignItems, getWidgetAggregateFunctions, widgetAllAggregateFunctions, getWidgetFontColors } from "./utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const GridWidgetColumnMenu = props =>{
    const {widgetId, column, onColumnSettingChange, schema, fields, settingsVisible, ruleVisible, onSettingsVisibleChange, onRuleVisibleChange,t, ...other} = props;
    const currentTheme = useSelector(state => state.currentTheme);
    const dispatch = useDispatch();
    const colors = getWidgetFontColors(currentTheme);

    const columnName = column.field;
    const _schema = schema.find(e => e.Name == columnName);
    const _field = fields.find(e => e.name == columnName);
    const _dataTypeId = _schema.DataTypeId;
    const comparisonOperators = getUnaryComparisonOperatorsByDataType(_dataTypeId)

    const widgetAggregateFunctions = getWidgetAggregateFunctions(_schema.DataTypeId);

    
    return (
        <div 
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onBlur={(e) => e.stopPropagation()}
        >
            <div className={`grid-widget-column-menu grid-widget-column-menu-${_schema.DataTypeId}`} >                
                {
                /* <GridColumnMenuSort {...props} /> */}

                <GridColumnMenuFilter {...props} />
                
                <div className="header" onClick={onSettingsVisibleChange}>
                    <div style={{padding: "0 6px"}}><span className="k-icon k-i-gear" style={{}}></span><span style={{marginLeft:4}}>Settings</span></div>                   
                </div>
                {
                    settingsVisible && 
                    <div className="content">
                        <div className="row" style={{}}>
                            <div className="column-left">
                                <div>{i18next.t("extras.fontsize")}</div>
                                <div style={{marginTop:3}}>
                                    <DropDownListById data={fontSizes} value={_field.fontSize} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "fontSize", e.value)} />
                                </div>
                            </div>
                            <div className="column-right" style={{flexDirection: "row", justifyContent: "space-between", alignSelf: "flex-end"}}>
                                <Checkbox checked={_field.fontIsBold} label={i18next.t("extras.bold")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "fontIsBold", e.target.value)}/>
                                <Checkbox checked={_field.fontIsItalic} label={i18next.t("extras.italic")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "fontIsItalic", e.target.value)}/>
                                <Checkbox checked={_field.fontIsUnderline} label={i18next.t("extras.underline")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "fontIsUnderline", e.target.value)}/>
                            </div>
                        </div>

                        <div className="row" style={{}}>
                            <div className="column-left" style={{}}>
                                <div>{i18next.t("extras.color")}</div>
                                <div style={{marginTop:3}}>                                    
                                    <DropDownListById data={colors} value={_field.fontColor} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "fontColor", e.value)} />
                                </div>
                            </div>
                            <div className="column-right" style={{}}>
                                <div>{i18next.t("extras.background")}</div>
                                <div style={{marginTop:3}}>
                                    <DropDownListById data={colors} value={_field.backgroundColor} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "backgroundColor", e.value)} />
                                </div>                           
                            </div>
                        </div>

                        <div className="row" style={{}}>
                            <div className="column-left">
                                <div>{i18next.t("extras.halign")}</div>
                                <div style={{marginTop:3}}>
                                    <DropDownListById data={hAlignItems} value={_field.hAlign} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "hAlign", e.value)} />
                                </div>
                            </div>
                            <div className="column-right" style={{flexDirection: "row", justifyContent: "space-between", alignSelf: "flex-end"}}>
                                <Checkbox checked={_field.isLocked} label={i18next.t("extras.locked")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "isLocked", e.target.value)}/>                   
                                {
                                    _schema.DataTypeId == 2 &&
                                    <Fragment>
                                        <Checkbox checked={_field.isVariation} label={i18next.t("extras.variation")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "isVariation", e.target.value)}/>                   
                                        <Checkbox checked={_field.isVariationReverse} label={i18next.t("extras.reverse")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "isVariationReverse", e.target.value)}/>                   
                                    </Fragment>
                                }
                            </div>
                        </div>
                        
                        <div className="row" style={{}}>
                            <div className="column-left">
                                <div>{i18next.t("extras.aggregate")}</div>
                                <div style={{marginTop:3}}>
                                    <DropDownListById data={widgetAggregateFunctions} value={_field.aggregate} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "aggregate", e.value)} />
                                </div> 
                            </div>
                            <div className="column-right">
                            {
                                _schema.DataTypeId == 2 &&
                                <Fragment>
                                    <div>{i18next.t("extras.thousandSeparator")}</div>
                                    <div style={{marginTop:3}}>
                                        <DropDownListById data={thousandSeparators} value={_field.thousandSeparator} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "thousandSeparator", e.value)} />
                                    </div>
                                </Fragment>
                            }
                            {
                                (_schema.DataTypeId == 4 || _schema.DataTypeId == 5) &&
                                <Fragment>
                                    <div>{i18next.t("extras.dateFormat")}</div>
                                    <div style={{marginTop:3}}>
                                        <DropDownListById data={dateFormats} value={_field.dateFormat} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "dateFormat", e.value)} />
                                    </div>
                                </Fragment>
                            }                                
                            </div>
                        </div>                        

                        {
                            _schema.DataTypeId == 2 && _schema.IsDecimal &&
                            <div className="row" style={{}}>
                                <div className="column-left">
                                    <div>{i18next.t("extras.decimalplaces")}</div>
                                    <div style={{marginTop:3}}>
                                        <DropDownListById data={decimalPlaces} value={_field.decimalPlaces} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "decimalPlaces", e.value)} />
                                    </div>
                                </div>
                                <div className="column-right" style={{flexDirection: "row", justifyContent: "space-between", alignSelf: "flex-end"}}>                                    
                                    {
                                        _schema.IsPercent && 
                                        <Checkbox checked={_field.showPercent} label={i18next.t("extras.show")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "showPercent", e.target.value)}/>
                                    }
                                </div>
                            </div>
                        }
                        {
                            _schema.DataTypeId == 2 && !_schema.IsDecimal && _schema.IsPercent &&
                            <div className="row" style={{}}>
                                <div className="column-left">
                                    <Checkbox checked={_field.showPercent} label={i18next.t("extras.show")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "showPercent", e.target.value)}/>
                                </div>
                                <div className="column-right">                                    
                                </div>
                            </div>
                        }                        
                    </div>
                }

                {
                    (_dataTypeId == 1 || _dataTypeId == 2) &&
                    <Fragment>
                        <div className="header" onClick={onRuleVisibleChange}>
                            <div style={{padding: "0 6px"}}><span className="k-icon k-i-edit" style={{}}></span><span style={{marginLeft:4}}>Rule</span></div>                   
                        </div>
                        {
                            ruleVisible && 
                            <div className="content">
                                {                                    
                                    <div style={{ }}>
                                        <div className="row" style={{}}>
                                        <div className="column-left">
                                            <div> {i18next.t("extras.operator")}</div>
                                            <div style={{marginTop:3}}>
                                                <DropDownListById data={comparisonOperators} value={_field.ruleOperator} dataItemKey="Id" textField="Title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleOperator", e.value)} />
                                            </div>
                                        </div>
                                        <div className="column-right" >                                    
                                            <div>{i18next.t("extras.value")}</div>
                                            <div style={{marginTop:3}}>
                                                <Input autoFocus value={_field.ruleValue} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleValue", e.target.value)} />
                                            </div>
                                        </div>
                                        </div>

                                        <div className="row" style={{}}>
                                            <div className="column-left">
                                                <div>{i18next.t("extras.fontsize")}</div>
                                                <div style={{marginTop:3}}>
                                                    <DropDownListById data={fontSizes} value={_field.ruleFontSize} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleFontSize", e.value)} />
                                                </div>
                                            </div>
                                            <div className="column-right" style={{flexDirection: "row", justifyContent: "space-between", alignSelf: "flex-end"}}>
                                                <Checkbox checked={_field.ruleFontIsBold} label={i18next.t("extras.bold")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleFontIsBold", e.target.value)}/>
                                                <Checkbox checked={_field.ruleFontIsItalic} label={i18next.t("extras.italic")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleFontIsItalic", e.target.value)}/>
                                                <Checkbox checked={_field.ruleFontIsUnderline} label={i18next.t("extras.underline")} onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleFontIsUnderline", e.target.value)}/>
                                            </div>
                                        </div>

                                        <div className="row" style={{}}>
                                            <div className="column-left" style={{}}>
                                                <div>{i18next.t("extras.color")}</div>
                                                <div style={{marginTop:3}}>                                    
                                                    <DropDownListById data={colors} value={_field.ruleFontColor} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleFontColor", e.value)} />
                                                </div>
                                            </div>
                                            <div className="column-right" style={{}}>
                                                <div>{i18next.t("extras.background")}</div>
                                                <div style={{marginTop:3}}>
                                                    <DropDownListById data={colors} value={_field.ruleBackgroundColor} dataItemKey="id" textField="title" onChange={e => onColumnSettingChange(dispatch, widgetId, _field.id, _field.name, "ruleBackgroundColor", e.value)} />
                                                </div>                           
                                            </div>
                                        </div>
                                    </div>                        
                                }
                            </div>
                        }
                    </Fragment>
                }

                
            </div>
            <style>
            {
                `
                    /*column menu*/
                    .k-grid-columnmenu-popup
                    {
                        /*width of the column menu form*/
                        width: min(450px, calc(100vw - 24px));
                        max-width: calc(100vw - 24px);
                        max-height: calc(100dvh - 24px);
                        box-sizing: border-box;
                        overflow-y: auto;
                        border: 1px solid ${currentTheme.separatorColor};
                    }

                    .grid-widget-column-menu
                    {      
                    }

                    .grid-widget-column-menu > .header
                    {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 4px 8px 8px 2px;
                        border-top: 1px solid ${currentTheme.separatorColor};
                    }

                    .grid-widget-column-menu > .header:hover
                    {
                        background-color: ${currentTheme.componentBorderColor};
                        cursor: pointer;
                    }

                    .grid-widget-column-menu > .content
                    {
                        display: flex;
                        flex-direction: column;
                        align-item: center;
                        padding: 12px;
                        /*max-height: 300px;
                        overflow-y: scroll;*/
                    }

                    .grid-widget-column-menu > .content .row
                    {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        padding: 0px 12px 12px 12px;
                        
                    }

                    .grid-widget-column-menu > .content .row .column-left
                    {
                        display: flex;
                        flex-direction: column;
                        flex: 2;
                    }

                    .grid-widget-column-menu > .content .row .column-right
                    {
                        display: flex;
                        flex-direction: column;
                        flex: 3;
                        margin-left:16px;
                    }

                    .grid-widget-column-menu > .content .row .k-dropdownlist
                    {
                        
                    }

                    @media (max-width: 700px)
                    {
                        .k-popup.k-column-menu.k-column-menu-popup.k-grid-columnmenu-popup
                        {
                            position: fixed !important;
                            top: 50% !important;
                            right: auto !important;
                            bottom: auto !important;
                            left: 50% !important;
                            transform: translate(-50%, -50%) !important;
                            width: min(450px, calc(100vw - 32px)) !important;
                            max-width: calc(100vw - 32px);
                            max-height: calc(100dvh - 64px);
                            overflow-y: auto;
                        }

                        .grid-widget-column-menu > .content
                        {
                            padding: 10px;
                        }

                        .grid-widget-column-menu > .content .row
                        {
                            flex-wrap: wrap;
                            gap: 8px;
                            padding: 0 0 12px;
                        }

                        .grid-widget-column-menu > .content .row .column-left,
                        .grid-widget-column-menu > .content .row .column-right
                        {
                            flex: 1 1 100%;
                            min-width: 0;
                        }

                        .grid-widget-column-menu > .content .row .column-right
                        {
                            margin-left: 0;
                        }

                        .grid-widget-column-menu > .content .k-dropdownlist,
                        .grid-widget-column-menu > .content .k-input
                        {
                            width: 100%;
                            max-width: 100%;
                        }
                    }
                `
            }
            </style>
        </div>
    );
};

const GridWidgetContent = props => {
    const {
        id, pageSize, currentPageIndex, fields, data, schema,
        groupable, filterable, gridRef,
        onColumnReorder, onColumnResize, onColumnSettingChange, onSort, onPageChange, onGroupChange,
        tempFilter, onTempFilter, t,
        ...other 
    } = props;

    const navigationAttributes = useTableKeyboardNavigation(id);

    const currentTheme = useSelector(state => state.currentTheme);
    const dispatch = useDispatch();
    const [isNarrowViewport, setIsNarrowViewport] = useState(
        () => window.matchMedia("(max-width: 1024px)").matches,
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 1024px)");
        const updateViewport = (event) => setIsNarrowViewport(event.matches);

        mediaQuery.addEventListener("change", updateViewport);
        return () => mediaQuery.removeEventListener("change", updateViewport);
    }, []);

    const colors = getThemeColors(currentTheme);
    const disableColumnDrag = props.mode == 2 && isNarrowViewport;
    
    let aggregates = fields.filter(e => e.aggregate).map(f => ({field: f.name, aggregate: f.aggregate}));

    /*events handlers*/
    const handleOnColumnReorder = e => {
        if (onColumnReorder)
            onColumnReorder(dispatch, id, e.columns);
    };

    const handleOnColumnResize = e => {
        if (onColumnResize)
            onColumnResize(dispatch, id, e.targetColumnId, e.oldWidth, e.newWidth, e.columns, e.end);
    };
    
  
    /*cell rendering*/
    const isRuleTrue = (field, dataType, v) => {
        //console.log("isRuleTrue: ", field, dataType, v)
        //check if a valid rule exists and if not return false; even if exists and does not apply return false else return true
        if (!field || !dataType || v == null || v == undefined)
            return false;

        let operator = field.ruleOperator;
        let value = field.ruleValue;

        if (operator > 0 && (dataType == 1 || dataType == 2))
        {
            if (dataType == 1 && operator == 5 && value && (value.trim().toLowerCase() == 'true' || value.trim().toLowerCase() == 'false'))//bool and equal
            {
                if ((value.trim().toLowerCase() == 'true' && v == true) || (value.trim().toLowerCase() == 'false' && v == false))
                    return true;
                else
                    return false;
            }

            if (dataType == 2 && operator >= 1 && operator <= 6 && compareUnary(v, operator, value))
                return true;
        }
        
        return false;
    };

    const cellRenderer = (props) =>
    {
        const { dataIndex, dataItem, rowType, ...other} = props;

        if (rowType == "groupHeader")//no need to do anything       
            return undefined;            
        else if (rowType === "groupFooter") { 
            //test if field has aggregate
            let aggregate = aggregates.find(e => e.field == props.field);   
            if (aggregate && props.dataItem.aggregates[aggregate.field] && props.dataItem.aggregates[aggregate.field][aggregate.aggregate]) 
            {
                //field has aggregate
                let fieldName = aggregate.field;
                let aggTitle = widgetAllAggregateFunctions.find(e => e.id == aggregate.aggregate).title;
                let aggValue = props.dataItem.aggregates[fieldName][aggregate.aggregate];
                let _schema = schema.find(e => e.Name == fieldName);
                let _field = fields.find(e => e.name == fieldName);

                let style= props.style;

                if (_field.hAlign == 1)
                    style.textAlign = "left";
                else if (_field.hAlign == 2)
                    style.textAlign = "center";
                else
                    style.textAlign = "right";

                style.fontSize = _field.fontSize;
                style.backgroundColor = colors.find(e => e.id == _field.backgroundColor).color;
                style.color = colors.find(e => e.id == _field.fontColor).color;
                style.fontSize = _field.fontSize;
                style.fontWeight = _field.fontIsBold ? 700 : 400;
                style.textDecoration = _field.fontIsUnderline ? "underline" : "none";
                style.fontStyle = _field.fontIsItalic ? "italic" : "normal";

                let resolvedData = aggValue;

                if (resolvedData == null)
                    resolvedData = "Null";
                else if (_schema.DataTypeId == 4 || _schema.DataTypeId == 5)//date
                {
                    let resolvedDateFormat = dateFormats.find (e => e.id == _field.dateFormat).title;
                    resolvedData = formatDate(resolvedData, resolvedDateFormat);
                }
                else if (_schema.DataTypeId == 2)
                {
                    const resolvedThousandSeparator = thousandSeparators.find(e => e.id == _field.thousandSeparator).title;

                    if (_field.aggregate == "average")//avg                    
                        resolvedData = formatNumber(resolvedData, 2, resolvedThousandSeparator);                    
                    else if (_schema.IsDecimal)
                        resolvedData = formatNumber(resolvedData, _field.decimalPlaces, resolvedThousandSeparator);
                    else 
                        resolvedData = formatNumber(resolvedData, 0, resolvedThousandSeparator);
                    
                    if (_schema.IsPercent && _field.showPercent)
                        resolvedData += "%";
                }

                return (
                    <td className={props.className} style={{...style}}  aria-colindex={props.columnIndex} role={"gridcell"}>
                        {aggTitle}={resolvedData}
                    </td>
                );            
            }     
            else
            {
                //no aggregate for the field => draw empty cell
                return (<td className={props.className} style={{}} aria-colindex={props.columnIndex} role={"gridcell"}></td>);
            }
        }

        //this is a data row
        let groupCount = !group ? 0 : group.length;
        let columnIndex = props.columnIndex - groupCount;//groupCount was always 0 but i kept this code in order to take no risk at all

        let fieldName = props.field;
        let rowIndex = dataIndex;
        let style = props.style;        
        let _field = fields.find(e => e.name == fieldName);//[columnIndex];//assuming that fields have sorted items in its order
        let _schema = schema.find (e => e.Id == _field.id);

        if (_field.hAlign == 1)
            style.textAlign = "left";
        else if (_field.hAlign == 2)
            style.textAlign = "center";
        else
            style.textAlign = "right";

        let resolvedData = dataItem[_field.name];

        //computing the style, check first if rule applies
        let ruleOk = isRuleTrue(_field, _schema.DataTypeId, resolvedData);
        if (ruleOk)
        {
            style.fontSize = _field.ruleFontSize;
            style.color = colors.find(e => e.id == _field.ruleFontColor).color;
            style.backgroundColor = colors.find(e => e.id == _field.ruleBackgroundColor).color;
            style.fontWeight = _field.ruleFontIsBold ? 700 : 400;
            style.textDecoration = _field.ruleFontIsUnderline ? "underline" : "none";
            style.fontStyle = _field.ruleFontIsItalic ? "italic" : "normal";
        }
        else
        {
            //no rule is defined on the field => check variation to set only font color
            if (_field.isVariation && dataItem[_field.name] != null)
            {
                if (dataItem[_field.name] >= 0)
                    style.color = _field.isVariationReverse ? currentTheme.error : currentTheme.success;
                else
                    style.color = _field.isVariationReverse ? currentTheme.success : currentTheme.error;
            }
            else
                style.color = colors.find(e => e.id == _field.fontColor).color;

            //continue with remaining props irrespective of variation
            style.fontSize = _field.fontSize;
            style.backgroundColor = colors.find(e => e.id == _field.backgroundColor).color;
            style.fontWeight = _field.fontIsBold ? 700 : 400;
            style.textDecoration = _field.fontIsUnderline ? "underline" : "none";
            style.fontStyle = _field.fontIsItalic ? "italic" : "normal";
        }       


        if (resolvedData == null)
            resolvedData = "Null";
        else if (_schema.DataTypeId == 4 || _schema.DataTypeId == 5)
        {
            let resolvedDateFormat = dateFormats.find (e => e.id == _field.dateFormat).title;
            resolvedData = formatDate(resolvedData, resolvedDateFormat);
        }
        else if (_schema.DataTypeId == 2)
        {
            const resolvedThousandSeparator = thousandSeparators.find(e => e.id == _field.thousandSeparator).title;

            if (_schema.IsDecimal)
                resolvedData = formatNumber(resolvedData, _field.decimalPlaces, resolvedThousandSeparator);
            else 
                resolvedData = formatNumber(resolvedData, 0, resolvedThousandSeparator);
            
            if (_schema.IsPercent && _field.showPercent)
                resolvedData += "%";            
        }
        else if (_schema.DataTypeId == 1)
        {
            resolvedData = resolvedData == true ? "True" : "False";
        }
        
        //let classNameResolved = _field.isLocked ? "k-grid-content-sticky" : undefined;

        //if variation => we need to render html to include the up/down arrow
        if (_schema.DataTypeId == 2 && _field.isVariation && dataItem[_field.name] != null)
        {
            let _val = dataItem[_field.name];

            let _barColor = ((_val >=0 && !_field.isVariationReverse) || (_val < 0 && _field.isVariationReverse)) ? currentTheme.success : currentTheme.error;

            resolvedData = (
                <Fragment>
                    <span>{resolvedData}</span>
                    {
                        parseFloat(resolvedData) > 0 &&
                        <span className="k-icon k-i-sort-asc-sm" style={{color: _barColor}}></span>
                    }
                    {
                        parseFloat(resolvedData) < 0 &&
                        <span className="k-icon k-i-sort-desc-sm" style={{color: _barColor}}></span>
                    }
                </Fragment>
            );
        }
        return (
            <td 
                className={props.className} // this adds classes needed for locked columns
                colSpan={props.colSpan}
                role={"gridcell"}
                aria-colindex={props.ariaColumnIndex}
                aria-selected={props.isSelected}
                {...{
                    [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
                }}
                {...navigationAttributes}
                style={style}>
                    {resolvedData}
            </td>
        );
    }

    /*sorting*/
    const [sort, setSort] = useState(state => {
        let _sort = [];

        for (let i in fields)
        {
            const field = fields[i];            
            if (field.isSorted)
                _sort.push({field: field.name, dir: field.sortDirection || "asc"})
        }
        
        return _sort;
    });

    const onSortChange = (e) => {        
        setSort([...e.sort]);

        if (onSort)
            onSort(dispatch, id, e.sort);
    };


    /*filtering*/
    const [filter, setFilter] = useState(state =>
    {
        return tempFilter;
        //return {filters: tempFilter, logic: "and"};
    });

    const handleOnFilterChange = e => 
    {
        if (onTempFilter)
            onTempFilter(dispatch, id, e.filter)

        //just set the state variable and go to page 0
        setFilter(e.filter);

        if (onPageChange)
            onPageChange(dispatch, id, {skip: 0, take: pageSize});
    };


    /*paging*/
    let take = pageSize;
    let skip = currentPageIndex*take;
    const total = useRef(data.length);//initially it is the total  number of rows in data since initial filtering is nothing

    const handleOnPageChange = e => {
        if (onPageChange)
            onPageChange(dispatch, props.id, e.page);
    };


    const [processedData, setProcessedData] = useState(state => {
        //initially, this is the data sorted and paged; filtering is null initially  and grouping is managed outside processedData
        let _data = [...data];

        if (sort && sort.length > 0)
            _data = orderBy(_data, sort)
            
        _data = _data.slice(skip, skip + take);

        //filtering - no need because filtering is not saved in db
        //_data = process(_data, {filter: filter});

        return _data;
    });


    /*group*/
    const [collapsedState, setCollapsedState] = useState([]);

    const onExpandChange = useCallback(
        (e) => {
          const item = e.dataItem;

          if (item.groupId) {
            const newCollapsedIds = !e.value
              ? [...collapsedState, item.groupId]
              : collapsedState.filter((groupId) => groupId !== item.groupId);
          
              setCollapsedState(newCollapsedIds);
          }
        },
        [collapsedState]
    );

    const processWithGroups = (data, group) => { 
        if (group)
            group = group.map(g => ({...g, aggregates: aggregates}));

        const newDataState = groupBy(data, group);
    
        setGroupIds({
          data: newDataState,
          group: group,
        });
        
        return newDataState;
    };

    const group = fields.filter(e => e.isGrouped==true)
    .sort((a, b) => (a.groupOrder > b.groupOrder) ? 1 : -1)
    .map(field => ({field: field.name, aggregates: aggregates}));

    const [resultState, setResultState] = useState(
        processWithGroups(processedData, group)
      );


    const handleOnGroupChange = e => {
        //there should be no 2 fields in e.group with the same name
        for (let i in e.group)
        {
            let count = 0;

            let f = e.group[i].field;
            for (let j in e.group)
            {
                if (e.group[j].field == f)
                {
                    count++;
                    if (count > 1)
                        return;
                }
            }
        }

        const newDataState = processWithGroups(processedData, e.group);

        if (onGroupChange)
            onGroupChange(dispatch, props.id, e.group);
        
        setResultState(newDataState);
    };

    const newData = setExpandedState({
        data: resultState,
        collapsedIds: collapsedState,
    });


    /*prepare data so that it handles sorting, filtering and paging and at the end apply grouping if any*/
    /*processedData includes the sorted, filtered and paged data but NOT the grouped one which is in resultState*/
    /*this way when grouping changes, we apply the new grouping on processed data and when filtering, sorting or paging changes*/
    /*we also rebuild processedData from data and then apply filtering, ordering and paging and then we compute resultState*/
    /*by applying grouping on the new processedData*/
    //when user changes a field aggregate, the grid used NOT to render the aggregate unless we change the data such as reordering
    //because the below useEffect does not depend on the fields array that changes in the column menu; to solve this issue we use
    //the below code and rely on useRef to detect when any field in fields changed its aggregate, when so we change the ref variable
    //that we made useEffect depends on 
    const fieldsAggregates = fields.map(e => e.aggregate);
    const fieldsAggregatesRef = useRef(fieldsAggregates);
    const fieldsAggregatesChanged = useRef(0);

    //test if any field has its aggregate changed and in this case update ref
    if (fieldsAggregates.length != fieldsAggregatesRef.current.length)    
        fieldsAggregatesChanged.current++;
    else 
    {
        //they have same size
        for (let i=0; i <fieldsAggregates.length; i++)
        {
            if (fieldsAggregates[i] != fieldsAggregatesRef.current[i])
            {
                fieldsAggregatesRef.current = [...fieldsAggregates];
                fieldsAggregatesChanged.current++;
                break;
            }
        }
    }   

    useEffect(() => {
        let sortedData = [];
        let filteredData = [];

        if (!filter || !filter.filters || filter.filters.length == 0)
            filteredData = [...data];
        else
            filteredData = process([...data], {filter}).data;

        if (!sort || sort.length == 0)
            sortedData = filteredData;
        else
            sortedData = orderBy(filteredData, sort);

        //total includes all the pages 
        total.current = sortedData.length;

        let processedData = sortedData.slice(skip, take + skip);
        
        setProcessedData(processedData);

        setResultState(processWithGroups(processedData, group));        
    }, [data, sort, filter, currentPageIndex, pageSize, fieldsAggregatesChanged.current]);//, fieldsAggregatesChanged.current//add fields to solve the issue of being able to change aggregate of a field and viewing the result without having to re-group


    //export to excel
    //the client passes a property: exportToExcel={true}, this code exports to excel as long as exportToExcel has not changed and is true
    //originally, it's false, so client re-renders with true and after 1sec he reset it to false; even if many re-renders occur within
    //this one second period, nothing happens as exportToExcel is true and has not changed
    const exportToExcelRef = useRef(null);

    const doExportToExcel = () => {
        if (exportToExcelRef.current !== null && (props.mode != 2 || (props.mode == 2 && props.loaded))) 
            exportToExcelRef.current.save();     //was on oct 1 2023 i passed newData as parameter but it was NOT working when exporting grouped data 
    };

    useEffect(() => {
        if (props.exportToExcel == true)
            doExportToExcel();
    }, [props.exportToExcel]);
  

    //column menu - make sure the settings and rules section behave correctly
    const [settingsVisible, setSettingsVisible] = useState(true);
    const [ruleVisible, setRuleVisible] = useState(false);

    const handleOnSettingsVisibleChange = (e) => {
        e.stopPropagation();
        setSettingsVisible(!settingsVisible);
        setRuleVisible(ruleVisible);
    };

    const handleOnRuleVisibleChange = (e) => {
        e.stopPropagation();
        setSettingsVisible(settingsVisible);
        setRuleVisible(!ruleVisible);
    };
    
    return (
        <Fragment>
           <div className={`grid-content grid-content-${id}`} style={{}}>
                <ExcelExport 
                    ref={exportToExcelRef}
                    group={group}
                    data={newData}
                    collapsible={true} 
                    >
                    <Grid
                        style={{
                            height: "100%",
                            width: "100%"
                        }}            
                        resizable={!disableColumnDrag} onColumnResize={disableColumnDrag ? undefined : handleOnColumnResize}
                        reorderable={!disableColumnDrag} onColumnReorder={disableColumnDrag ? undefined : handleOnColumnReorder}
                        sortable={{
                            allowUnsort: true,
                            mode: "multiple",
                        }} sort={sort} onSortChange={onSortChange}
                        filterable={filterable ? true : undefined} 
                        filter={filter} onFilterChange={handleOnFilterChange}                   
                        pageable={true} take={take} skip={skip} total={total.current} 
                        onPageChange={handleOnPageChange}
                        groupable={groupable ? { footer: "visible"} : false}
                        data={newData} 
                        onGroupChange={handleOnGroupChange}
                        group={group}
                        onExpandChange={onExpandChange}
                        expandField="expanded"
                        // dataItemKey="name"
                    >
                        {
                            fields
                            .filter(e => e.isVisible == true)
                            .sort((a, b) => (a.orderId > b.orderId) ? 1 : -1)
                            .map((item, index) => {
                                return (
                                    <Column id={item.name} key={item.name} field={item.name} title={item.title} width={item.width ? item.width : undefined}                                                
                                        orderIndex={item.orderId} 
                                        locked={item.isLocked} 
                                        filter={item.filter}
                                        columnMenu={
                                            prps => (<GridWidgetColumnMenu widgetId={props.id} {...prps} onColumnSettingChange={onColumnSettingChange} 
                                                        schema={schema} fields={fields} t={t}
                                                        settingsVisible={settingsVisible}  onSettingsVisibleChange={handleOnSettingsVisibleChange }
                                                        ruleVisible={ruleVisible} onRuleVisibleChange={handleOnRuleVisibleChange} />)
                                        }
                                        cell={cellRenderer}                                        
                                        headerClassName={`${item.hAlign==2 ? 'grid-content-center-header' : (item.hAlign==3 ? 'grid-content-right-header' : undefined)}`}
                                        />
                                );
                            })
                        }
                    </Grid>
                </ExcelExport>
            </div>
            <style>
                {                    
                    `
                        .rpt-widget .k-grid-content
                        {
                            overflow: auto;

                        }

                        @media (max-width: 1024px)
                        {
                            .rpt-widget .k-grid-header,
                            .rpt-widget .k-grid-content
                            {
                                touch-action: pan-x pan-y;
                            }

                            .rpt-widget-grid .grid-content,
                            .rpt-widget-grid .k-grid
                            {
                                min-height: 400px;
                            }
                        }
                        .rpt-widget .grid-content
                        {
                            margin-top: 8px;
                            text-align: center;       
                            flex: 1;
                            display: flex;                           
                            align-items: center;         
                            height: calc(100% - 8px);
                        }

                        .rpt-widget-grid table
                        {
                            border-collapse: collapse;
                        }

                        .rpt-widget .grid-content th
                        {                           
                        }

                        .rpt-widget .grid-content-center-header
                        {
                            width: 100%;
                            justify-content: center;
                        }

                        .rpt-widget .grid-content-right-header
                        {
                            width: 100%;
                            justify-content: flex-end;
                        }

                        .rpt-widget .k-grid-pager
                        {
                            display: flex;
                            border: 1px solid ${currentTheme.separatorColor};
                            background-color: ${currentTheme.gridPagerBg};
                        }

                        /*.rpt-widget .k-grid tbody tr.k-master-row,
                        .rpt-widget .k-grid tbody tr.k-master-row.k-alt1
                        {
                            background-color: ${currentTheme.componentBg};
                            border-bottom: 1px solid ${currentTheme.separatorColor};
                        }*/

                        .rpt-widget .k-grid tbody tr.k-master-row td
                        {
                            border-bottom: 1px solid ${currentTheme.separatorColor};
                        }                      

                        /*the page number*/
                        .rpt-widget-grid .k-pager-numbers .k-link
                        {
                            color: ${currentTheme.gridPageNumberColor};
                            background-color: transparent;
                        }

                        .rpt-widget-grid .k-pager-numbers .k-link.k-selected 
                        {
                            color: ${currentTheme.gridPageSelectedNumberColor};
                        }

                        .rpt-widget-grid .k-pager-nav, .rpt-widget-grid .k-pager-nav:focus,
                        .rpt-widget-grid .k-pager-numbers .k-link:focus, .rpt-widget-grid .k-pager-numbers .k-link.k-selected:focus
                        {
                            box-shadow: none;
                        }

                        .rpt-widget-grid tr.k-group-footer
                        {
                        }
                    `
                }
            </style>
        </Fragment>
    );
};

export const GridWidget = props  => {
    const {                
        id, mode, 
        loaded, loading, errorText, canceled,
        backgroundColor, title, titleFontSize, titleFontIsBold, titleFontIsUnderline, titleFontIsItalic, titleFontColor,
        getContextMenu, onMenuItemClick, onWidgetSelect, onWidgetUnSelect, onDoubleClick, 
        ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const { t } = useTranslation();

    return (
        <Fragment>
             <ReportingWidget id={id} widgetTypeId={WIDGET_GRID} dataSourceValueType={0}
             mode={mode} loaded={loaded} loading={loading} errorText={errorText} canceled={canceled}
             backgroundColor={backgroundColor} title={title} titleFontSize={titleFontSize} titleFontIsBold={titleFontIsBold} 
             titleFontIsUnderline={titleFontIsUnderline} titleFontIsItalic={titleFontIsItalic} titleFontColor={titleFontColor}
             getContextMenu={getContextMenu} onMenuItemClick={onMenuItemClick} 
             onWidgetSelect={onWidgetSelect} onWidgetUnSelect={onWidgetUnSelect} 
             onDoubleClick={onDoubleClick} t={t}>
                <GridWidgetContent {...props} />
            </ReportingWidget>
            <style>
                {
                    `
                        
                    `
                }
            </style>
        </Fragment>
    );
};
